import React, { FunctionComponent } from 'react';

import { FilterInputType } from 'src/types';
import { TreeContainer } from '../../containers/TreeContainer';
import { FilterOptionsProps } from '../../types';
import { CheckboxGroupWrapper } from './CheckboxGroupWrapper';
import { RadioButtonGroupWrapper } from './RadioButtonGroupWrapper';
import { RangeInputWrapper } from './RangeInputWrapper/RangeInputWrapper';

export const FilterOptions: FunctionComponent<FilterOptionsProps> = (props: FilterOptionsProps) => {
  switch (props.filter.type) {
    case FilterInputType.Checkbox:
      return <CheckboxGroupWrapper {...props} />;
    case FilterInputType.Radio:
      return <RadioButtonGroupWrapper {...props} />;
    case FilterInputType.Range:
      return <RangeInputWrapper {...props} />;
    case FilterInputType.Tree:
      return <TreeContainer {...props} />;
    default:
      return null;
  }
};
